/** Parse set count from prescription strings (`4x8`, `4×5 @ 80 kg`, etc.). */
export function parseSetCount(prescription: string): number {
  const normalized = prescription.replace(/×/g, 'x')
  const match = normalized.match(/(\d+)\s*x\s*\d+/i) ?? normalized.match(/(\d+)\s*x/i)
  return match ? Number(match[1]) : 3
}

/** Extract target load in kg from a prescription line, if present. */
export function parsePrescriptionWeightKg(prescription: string): number | null {
  const match = prescription.match(/@\s*([\d.]+)\s*kg/i)
  if (!match) return null
  const value = Number(match[1])
  return Number.isFinite(value) ? value : null
}

/** Human-readable sets × reps without duplicating the load line. */
export function formatPrescriptionDetail(prescription: string): string {
  return prescription.replace(/@\s*[\d.]+\s*kg\s*/i, '').trim()
}
